// rem转换
function Rem() {
  var docEl = document.documentElement
  var oSize = docEl.clientWidth / 7.5
  docEl.style.fontSize = oSize + 'px'
}

window.addEventListener('resize', Rem, false)
Rem()
